import { Injectable } from '@angular/core';

// Pure helper exported for callers that cannot inject DI (e.g. NgRx reducers).
// toLowerCase() is used (not toLocaleLowerCase) so two users in different
// locales compare filenames identically — e.g. Turkish toLocaleLowerCase
// maps I (U+0049) → ı (U+0131, dotless i), which would otherwise cause
// cross-user mismatches on Sync.com.
export function nfcLower(value: string): string {
  return value.normalize('NFC').toLowerCase();
}

@Injectable({
  providedIn: 'root',
})
export class NameNormalizeService {
  public toNfc(value: string): string {
    return value.normalize('NFC');
  }

  public toNfcLower(value: string): string {
    return nfcLower(value);
  }

  public equalsByName(a: string, b: string): boolean {
    return this.toNfcLower(a) === this.toNfcLower(b);
  }
}
